// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"cb8e6846","93":"7be603d9","180":"5ab2444c","774":"e1785866"}[chunkId] + ".chunk.js";
};